import styled from 'styled-components';
import { Icon } from '@material-ui/core';
import VersionContainer from '@domain/game.selection/version.container';

export const UserMenuListIcon = styled(Icon)`
  margin-right: 12px;
  color: #666;
`;

export const VersionItem = styled(VersionContainer)`
  margin: 12px 18px 6px 12px;
  text-align: right;
`;
